import SvgIcon from './SvgIcon';

export default function NewTabIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14" version="1.1">
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        opacity="0.5">
        <g
          id="Embed-Tab"
          transform="translate(-702.000000, -248.000000)"
          fill="#5C8AD9"
          fillRule="nonzero">
          <g id="Content" transform="translate(152.000000, 200.000000)">
            <g id="Preview" transform="translate(0.000000, 30.000000)">
              <g id="New-Tab-Icon" transform="translate(550.000000, 18.000000)">
                <path
                  d="M13.3293846,13.8813846 L0.794769231,13.8813846 C0.432615385,13.8813846 0.138923077,13.5876923 0.138923077,13.2255385 L0.138923077,0.690923077 C0.138923077,0.328769231 0.432615385,0.0350769231 0.794769231,0.0350769231 L6.25692308,0.0350769231 C6.61907692,0.0350769231 6.91276923,0.328769231 6.91276923,0.690923077 C6.91276923,1.05307692 6.61907692,1.34676923 6.25692308,1.34676923 L1.45061538,1.34676923 L1.45061538,12.5698462 L12.6736923,12.5698462 L12.6736923,7.93061538 C12.6736923,7.56846154 12.9673846,7.27476923 13.3295385,7.27476923 C13.6916923,7.27476923 13.9853846,7.56846154 13.9853846,7.93061538 L13.9853846,13.2255385 C13.9852308,13.5876923 13.6915385,13.8813846 13.3293846,13.8813846 Z"
                  id="Shape"
                />
                <path
                  d="M13.9847692,0.690923077 L13.9847692,4.67969231 C13.9847692,5.042 13.6913846,5.33553846 13.3289231,5.33553846 C12.9666154,5.33553846 12.6730769,5.04215385 12.6730769,4.67969231 L12.6730769,2.27461538 L7.08938462,7.85846154 C6.95984615,7.98630769 6.79261538,8.05030769 6.62538462,8.05030769 C6.45646154,8.05030769 6.28923077,7.98630769 6.16138462,7.85846154 C5.90569231,7.60276923 5.90569231,7.188 6.16138462,6.93215385 L11.7452308,1.34661538 L9.34030769,1.34661538 C8.978,1.34661538 8.68446154,1.05307692 8.68446154,0.690769231 C8.68446154,0.328461538 8.978,0.0349230769 9.34030769,0.0349230769 L13.3290769,0.0349230769 C13.3733846,0.0349230769 13.4175385,0.0398461538 13.4618462,0.048 C13.4832308,0.0529230769 13.5044615,0.0578461538 13.5241538,0.0644615385 C13.5455385,0.0710769231 13.5650769,0.0775384615 13.5847692,0.0873846154 C13.6012308,0.094 13.6175385,0.100461538 13.634,0.110307692 C13.6536923,0.120153846 13.6716923,0.13 13.6896923,0.143076923 C13.7076923,0.154615385 13.7256923,0.167692308 13.7438462,0.182461538 C13.7603077,0.195538462 13.7766154,0.210307692 13.7930769,0.226769231 C13.8701538,0.303846154 13.9241538,0.397230769 13.9553846,0.495692308 C13.962,0.517076923 13.9669231,0.538307692 13.9718462,0.559692308 C13.9798462,0.602461538 13.9847692,0.646615385 13.9847692,0.690923077 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

NewTabIcon.defaultProps = {
  width: '14px',
  height: '14px',
};
